/**
 * Share or copy an event link using the Web Share API with clipboard fallback.
 *
 * On mobile/supported browsers: opens native share sheet.
 * On desktop/unsupported: falls back to clipboard copy.
 *
 * @returns 'shared' | 'copied' indicating which action was taken
 */
export const shareEventLink = async (
    eventId: string,
    eventName?: string
): Promise<'shared' | 'copied'> => {
    const eventLink = `${window.location.origin}/event/${eventId}`;

    // Try native share first
    if (navigator.share) {
        try {
            await navigator.share({
                title: eventName || 'Split Bill',
                text: eventName
                    ? `Tham gia sự kiện "${eventName}" trên Split Bill`
                    : 'Tham gia sự kiện trên Split Bill',
                url: eventLink,
            });
            return 'shared';
        } catch (err) {
            // User cancelled or share failed — fall through to clipboard
            if ((err as Error).name === 'AbortError') {
                // User cancelled share — don't copy
                throw err;
            }
        }
    }

    // Fallback: copy to clipboard
    await navigator.clipboard.writeText(eventLink);
    return 'copied';
};
